export const FIELD_TYPE_TEXT = 'TEXT';
export const FIELD_TYPE_MULTICHOICE = 'MULTICHOICE';
